import { useEffect, useState } from "react";
import { getClientAll } from "tm-shared/api";
import { Option } from "tm-shared/types";

import { useProtectedUserRoleSelector } from "@/hooks/redux";
import { Header } from "@/shared/layout";
import { MainContainer } from "@/shared/layout/Layout";
import { PrimaryText } from "@/shared/ui/Typography";

import { CreatePointForm } from "./CreatePointForm";
import { CreatePointFormSkeleton } from "./CreatePointForm/CreatePointForm.Skeleton";
import { ModalsContainer } from "./modals/ModalsContainer";
import { getPointCreateCapabilities } from "./PointCreate.policy";

export const PointCreatePage = () => {
    const role = useProtectedUserRoleSelector();
    const capabilities = getPointCreateCapabilities(role);

    const [isLoadingPartners, setIsLoadingPartners] = useState(true);
    const [partnersLoadError, setPartnersLoadError] = useState<string | null>(
        null,
    );
    const [partnerOptions, setPartnerOptions] = useState<Option[]>([]);

    useEffect(() => {
        let isCancelled = false;

        const loadPartners = async () => {
            try {
                setIsLoadingPartners(true);
                setPartnersLoadError(null);

                const response = await getClientAll({ areaId: null });

                if (isCancelled) return;

                setPartnerOptions(
                    response.result.map(({ id, name }) => ({
                        value: id,
                        label: name,
                    })),
                );
            } catch (error) {
                if (isCancelled) return;

                console.error("Failed to fetch partners:", error);
                setPartnersLoadError("Не вдалося завантажити список партнерів");
            } finally {
                if (!isCancelled) {
                    setIsLoadingPartners(false);
                }
            }
        };

        loadPartners();

        return () => {
            isCancelled = true;
        };
    }, []);

    return (
        <>
            <Header title="Створити ТТ" back />

            <MainContainer>
                {isLoadingPartners && <CreatePointFormSkeleton />}

                {!isLoadingPartners && partnersLoadError && (
                    <PrimaryText
                        textAlign="center"
                        textColor="error"
                        fontSize={16}
                    >
                        {partnersLoadError}
                    </PrimaryText>
                )}

                {!isLoadingPartners && !partnersLoadError && (
                    <>
                        <CreatePointForm
                            capabilities={capabilities}
                            partnerOptions={partnerOptions}
                        />

                        <ModalsContainer />
                    </>
                )}
            </MainContainer>
        </>
    );
};
